import { id_pe, id_ce, id_pkix } from "@peculiar/asn1-x509";
export const id_pe_ac_auditIdentity = `${id_pe}.4`;
export const id_pe_aaControls = `${id_pe}.6`;
export const id_pe_ac_proxying = `${id_pe}.10`;
export const id_ce_targetInformation = `${id_ce}.55`;
export const id_aca = `${id_pkix}.10`;
export const id_aca_authenticationInfo = `${id_aca}.1`;
export const id_aca_accessIdentity = `${id_aca}.2`;
export const id_aca_chargingIdentity = `${id_aca}.3`;
export const id_aca_group = `${id_aca}.4`;
export const id_aca_encAttrs = `${id_aca}.6`;
export const id_at = "2.5.4";
export const id_at_role = `${id_at}.72`;
export const id_at_clearance = "2.5.1.5.55";
